const tasks = {
  notAvailable: 'Non disponible',
  executing: 'Exécution',
  finished: 'Terminé',
  success: 'Succès',
  any: 'Tout',
  general: {
    search: 'Rechercher par UUID',
    serialNmbr: 'Numéro de série',
  },
  selectors: {
    selector4: {
      last7Days: 'Les 7 derniers jours',
      custom: 'Personnalisé',
    },
  },
  table: {
    siteName: 'Nom du site',
    date: 'Date',
    status: 'Statut',
    id: 'ID',
    id_detail: 'ID Détail',
    serial_number: 'Numéro de série',
    commandtype: 'Type de commande',
    entitytype: "Type d'entité",
    started_at: 'Commencé à',
    finished_at: 'Terminé à',
  },
  modal: {
    title: 'Tâche du contrôleur-détail',
    header: 'En-tête',
  },
};

export default tasks;
